import { IdwalGrade } from "@idwal/idwal-react-components";
import "./GradeWindow.css";
import { useTranslation } from "react-i18next";

export const GradeWindow = (props: {
    gradeImageUrl?: string;
    adjustedGradeImageUrl?: string;
}) => {
    const { t } = useTranslation("locale");
    const gradeHeight = 96;
    const gradeWidth = 240;

    return (
        <div className="grade-window">
            <div className="flex md:flex-row flex-column align-items-center justify-content-center md:gap-8 gap-4 grade-scores">
                <div className="flex flex-column align-items-center justify-content-center">
                    {props.gradeImageUrl ? (
                        <img
                            src={props.gradeImageUrl}
                            alt="Inspected Grade"
                            width={gradeWidth}
                            height={gradeHeight}
                        />
                    ) : (
                        <IdwalGrade
                            grade={0}
                            size={"small"}
                            width={gradeWidth}
                            height={gradeHeight}
                        />
                    )}
                    <span className="pt-4">
                        {t("adjustedGrading.original_grade")}
                    </span>
                </div>
                <div className="flex flex-column align-items-center justify-content-center">
                    {props.adjustedGradeImageUrl ? (
                        <img
                            src={props.adjustedGradeImageUrl}
                            alt="Adjusted Grade"
                            width={gradeWidth}
                            height={gradeHeight}
                        />
                    ) : (
                        <IdwalGrade
                            grade={0}
                            size={"small"}
                            width={gradeWidth}
                            height={gradeHeight}
                        />
                    )}
                    <span className="pt-4">
                        {t("adjustedGrading.adjusted_grade")}
                    </span>
                </div>
            </div>
        </div>
    );
};
